export const CommunicationKitRouteName = {
  Template: 'communication-kit-template',
  Custom: 'communication-kit-custom',
};
